import React from 'react';
import './about.css';

import Biography from './Biography';
import EducationWork from './EducationWork';

import aboutme from '../../images/presentation.jpg'

export default function About() {
  return (
    <section id='About'>
      <Biography />
      <EducationWork />
      <img src={aboutme} alt="about me" className="img-fluid shadow-sm image--aboutme"/>
    </section>
  )
}
